import loadScript from 'load-script';

const AMAZON_APSTAG_URL = '//c.amazon-adsystem.com/aax2/apstag.js';

let loaded = false;

/**
 * This module / function allows the dynamic loading of google client
 * javascript library
 * @param  {Function} callback - the function to execute once google client api is loaded
 * @param  {Object}   options  - options for the loading of the script
 * @return {void}
 */
export default function (callback = null, options = {}) {
  if (loaded && typeof callback === 'function') {
    callback();
    return false;
  }

  if (loaded) {
    return false;
  }

  loadScript(AMAZON_APSTAG_URL, options, () => {
    loaded = true;
    if (typeof callback === 'function') {
      callback();
    }
  });
}
